module.exports = __webpack_public_path__ + "assets/img/dev1.26b41a27.png";